document.addEventListener('alpine:init', () => {
  function cartItemChangeForm(data = {}) {
    return {
      ...data,

      isLoading: false,

      get formData() {
        var formData = new FormData(this.$el);
  
        formData.set('sections', ['mini-cart']);
  
        return formData;
      },

      onSubmit({ isNativeSubmit }) {
        if (!this.$el.checkValidity()) return;

        if (isNativeSubmit) {
          return this.$el.submit();
        }

        if (this.isLoading) return;

        this.$dispatch('cartitemchangestart');
        
        this.isLoading = true;

        var fetchUrl = `${this.$el.action}.js`;
        
        var fetchOptions = {
          method: this.$el.method,
          body: this.formData
        };

        fetch(fetchUrl, fetchOptions)
          .then((res) => {
            if (!res.ok) {
              throw new Error();
            }

            return res.json();
          })
          .then((res) => {
            this.$dispatch('cartitemchangesuccess', { res });
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.$dispatch('cartitemchangeend');
            this.isLoading = false;
          });
      }
    };
  };

  Alpine.data('cartItemChangeForm', cartItemChangeForm);
});
